import React, { useContext } from 'react';
import {
  bool, oneOf, string
} from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';
import { StorePodLoader } from './StorePodLoader';

export const StorePodName = ({
  color,
  height,
  hideStoreNumber,
  hostName,
  label,
  linkType,
  variant,
  weight
}) => {
  const { loading, store } = useContext(StorePodContext);

  const { name, storeId, storeDetailsPageLink } = store;

  let placeholderHeight = '';

  switch (variant) {
  case 'h1':
    placeholderHeight = '3.8rem';
    break;
  case 'h2':
    placeholderHeight = '3.4rem';
    break;
  case 'h3':
    placeholderHeight = '2.8rem';
    break;
  case 'h4':
    placeholderHeight = '2.5rem';
    break;
  case 'h5':
    placeholderHeight = '2.5rem';
    break;
  default:
    placeholderHeight = '2rem';
    break;
  }

  if (loading) {
    return (
      <div data-testid="store-pod-name-loader">
        <StorePodLoader height={placeholderHeight} />
      </div>
    );
  }

  const linkMap = {
    rentals: {
      href: `${storeDetailsPageLink}/rentals`,
    },
    services: {
      href: `${storeDetailsPageLink}/services`,
    },
    store: {
      href: `${hostName}${storeDetailsPageLink}`,
    }
  };

  const { href } = linkMap[linkType];

  return (
    <a
      className="sui-items-center sui-flex"
      href={href}
    >
      <Typography
        color={color}
        data-testid="store-pod-name"
        height={height}
        variant={variant}
        weight={weight}
      >
        {label && (
          <span>{label}</span>
        )}
        <span>{name}</span>
        {!hideStoreNumber && (
          <span>&nbsp;#{storeId}</span>
        )}
      </Typography>
    </a>
  );
};

StorePodName.displayName = 'StorePodName';

StorePodName.propTypes = {
  color: oneOf(['primary', 'inverse']),
  height: oneOf(['snug', 'tight', 'normal', 'relaxed', 'loose']),
  hideStoreNumber: bool,
  hostName: string,
  label: string,
  linkType: oneOf(['rentals', 'services', 'store']),
  variant: oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'body-base']),
  weight: oneOf(['bold', 'condensed', 'regular'])
};

StorePodName.defaultProps = {
  color: 'primary',
  height: 'snug',
  hideStoreNumber: false,
  hostName: '',
  label: '',
  linkType: 'store',
  variant: 'h4',
  weight: 'condensed'
};
